/* ==========================================================================
   TWRD PDP-galleri paa telefon
   --------------------------------------------------------------------------
   Tre opgaver. Slider-biblioteket (Swiper via media-carousel.js) roeres ikke.

   1. Peek fra. Temaets data-mobile-next-image-preview giver Swiper en
      slidesOffsetAfter paa 9% af bredden, saa naeste slide kigger frem.
      Attributten udelades nu allerede i snippets/product-gallery.liquid.
      Koden her fjerner den stadig, hvis den kommer tilbage (temaeditor,
      cachet HTML, eller en anden sektion der bruger samme snippet), og
      reparerer en karrusel der allerede naaede at starte med offset.
   2. Taeller nederst til hoejre, "2 / 9". Opdateres paa karrusellens
      egne events: on:media-carousel:init og on:media-carousel:slide-change.
   3. Aktiv thumbnail rulles ind i billedet i thumbnail-raekken.

   VIGTIGT: twrd-variant-gallery.js bygger hele <media-gallery> op paa ny
   ved hvert farve- eller print-skift (host.innerHTML = template, derefter
   replaceChild). Den nye node er en kopi: attributter og boernenoder
   foelger med, men event-lyttere goer ikke. Derfor bindes der paa ny paa
   twrd:variant-gallery:rendered, og "er den bundet" holdes i et WeakSet,
   ikke i en attribut (en attribut ville blive kopieret med over).

   Alle vaerdier laeses, intet eksisterende objekt muteres ud over DOM.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__twrdGalleryMobile) return;
  window.__twrdGalleryMobile = true;

  var PHONE_MAX = 768; // samme braekpunkt som BREAKPOINTS.tab i utils.lib.js
  var COUNTER_CLASS = 'twrd-gallery-counter';
  var bound = new WeakSet();


  function isPhone() {
    return window.innerWidth <= PHONE_MAX;
  }

  function carousels() {
    try {
      return Array.prototype.slice.call(
        document.querySelectorAll('.product-single__media media-carousel.media-gallery__slider')
      );
    } catch (err) {
      return [];
    }
  }

  /* ---- 1. Peek fra paa telefon ------------------------------------------ */
  function disablePeek(carousel) {
    if (!carousel) return;
    var current = carousel.getAttribute('data-mobile-next-image-preview');
    if (current === null) return;
    // Gem den originale vaerdi, saa den kan saettes tilbage over 768px.
    carousel.setAttribute('data-twrd-peek', current);
    carousel.removeAttribute('data-mobile-next-image-preview');
    carousel.setAttribute('data-space-between', '0');
  }

  function restorePeek(carousel) {
    if (!carousel) return;
    var stored = carousel.getAttribute('data-twrd-peek');
    if (stored === null) return;
    carousel.setAttribute('data-mobile-next-image-preview', stored);
    carousel.removeAttribute('data-twrd-peek');
    carousel.removeAttribute('data-space-between');
  }

  function applyPeekState() {
    var list = carousels();
    for (var i = 0; i < list.length; i += 1) {
      if (isPhone()) {
        disablePeek(list[i]);
      } else {
        restorePeek(list[i]);
      }
    }
  }

  /* Sikkerhedsnet: naaede Swiper at starte med offset, er slidet smallere
     end karrusellen. Det kan ses direkte i DOM'en, uden at roere Swiper. */
  function needsRepair(carousel) {
    if (!isPhone()) return false;
    var slide = carousel.querySelector('.swiper-slide-active') || carousel.querySelector('.swiper-slide');
    if (!slide) return false;
    var slideWidth = slide.getBoundingClientRect().width;
    var railWidth = carousel.getBoundingClientRect().width;
    if (!slideWidth || !railWidth) return false;
    return Math.abs(railWidth - slideWidth) > 1;
  }

  /* media-carousel.js holder Swiper privat, men slideTo() returnerer
     instansen. Vi nulstiller offset og mellemrum og opdaterer, saa baade
     bredder og translate-positioner regnes om. Uden update() ville et swipe
     lande skaevt. Ingen effekt hvis Swiper aldrig blev bygget (returnerer
     null paa desktop-grid). */
  function repair(carousel) {
    if (!needsRepair(carousel)) return;
    var index = 0;
    try {
      if (typeof carousel.index === 'number' && carousel.index >= 0) index = carousel.index;
    } catch (err) {
      index = 0;
    }
    var swiper = null;
    try {
      swiper = typeof carousel.slideTo === 'function' ? carousel.slideTo(index, 0) : null;
    } catch (err) {
      return;
    }
    if (!swiper || !swiper.params) return;
    swiper.params.slidesOffsetAfter = 0;
    swiper.params.slidesOffsetBefore = 0;
    swiper.params.spaceBetween = 0;
    lockToZero(swiper.params, 'slidesOffsetAfter');
    lockToZero(swiper.params, 'spaceBetween');
    try {
      swiper.update();
    } catch (err) {
      /* Swiper kan vaere revet ned imens. Markuppen er stadig kant til kant. */
    }
  }

  /* media-carousel.js laver en ResizeObserver naar peek er slaaet til, og
     den saetter slidesOffsetAfter tilbage til 9% ved hver stoerrelsesaendring.
     Observeren kan ikke naas udefra. Derfor laases vaerdien til 0 med en
     tom setter: temaets tildeling bliver et no-op i stedet for at kaste
     (media-carousel.js er et modul og koerer i strict mode).
     Naar breakpointet skifter over "tab", river temaet Swiper ned og bygger
     et nyt params-objekt, saa laasen forsvinder af sig selv. */
  function lockToZero(params, key) {
    try {
      var descriptor = Object.getOwnPropertyDescriptor(params, key);
      if (descriptor && descriptor.get) return;
      Object.defineProperty(params, key, {
        configurable: true,
        get: function () {
          return 0;
        },
        set: function () {}
      });
    } catch (err) {
      /* Kan ikke laases. repair() koerer stadig paa resize. */
    }
  }

  /* ---- 2. Taeller -------------------------------------------------------- */
  /* twrd-variant-gallery.js FJERNER de medier der ikke hoerer til den valgte
     farve og det valgte print. De tilbagevaerende [data-slide] er derfor
     praecis de synlige slides. */
  function slideTotal(carousel) {
    try {
      return carousel.querySelectorAll('.js-slides [data-slide]').length;
    } catch (err) {
      return 0;
    }
  }

  function counterFor(carousel) {
    var existing = carousel.querySelector('.' + COUNTER_CLASS);
    if (existing) return existing;
    var el = document.createElement('div');
    el.className = COUNTER_CLASS;
    el.setAttribute('aria-hidden', 'true');
    carousel.appendChild(el);
    return el;
  }

  /* Det aktive indeks laeses ALTID af karrusellen selv, ikke af et husket
     tal. Efter et farve- eller print-skift er listen en anden, og et husket
     indeks ville pege paa et slide der ikke findes laengere.
     carousel.index er Swipers realIndex/activeIndex. Er Swiper ikke bygget
     (fx grid paa desktop), bruges det medsendte tal. */
  function activeIndex(carousel, fallback) {
    try {
      var live = carousel.index;
      if (typeof live === 'number' && live >= 0) return live;
    } catch (err) {
      /* Swiper er ikke bygget. */
    }
    return typeof fallback === 'number' && fallback >= 0 ? fallback : 0;
  }

  function writeCounter(carousel, index) {
    var total = slideTotal(carousel);
    if (!total) return;
    var safeIndex = activeIndex(carousel, index);
    // Blev listen kortere ved skiftet, kan indekset ligge uden for den.
    if (safeIndex > total - 1) safeIndex = total - 1;
    var el = counterFor(carousel);
    el.textContent = (safeIndex + 1) + ' / ' + total;
  }

  /* ---- 3. Aktiv thumbnail ind i billedet --------------------------------- */
  function scrollActiveThumb(gallery) {
    if (!gallery) return;
    var list = gallery.querySelector('.js-media-gallery-thumb-list');
    if (!list) return;
    var active = list.querySelector('.thumbnail-list__item--active');
    if (!active) return;
    if (list.scrollWidth <= list.clientWidth) return;
    var target = active.offsetLeft - (list.clientWidth - active.offsetWidth) / 2;
    var max = list.scrollWidth - list.clientWidth;
    var next = Math.max(0, Math.min(max, target));
    try {
      list.scrollTo({ left: next, behavior: 'smooth' });
    } catch (err) {
      list.scrollLeft = next;
    }
  }

  /* ---- Bind ------------------------------------------------------------- */
  function bind(carousel) {
    if (bound.has(carousel)) return;
    bound.add(carousel);

    var gallery = carousel.closest('media-gallery') || carousel.parentElement;
    var initial = Number(carousel.getAttribute('data-initial-slide') || 0);
    var lastIndex = isNaN(initial) ? 0 : initial;

    var onInit = function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (typeof detail.activeIndex === 'number') lastIndex = detail.activeIndex;
      // Startede Swiper alligevel med peek, rettes bredden her, foer
      // brugeren naar at se striben i hoejre side. Kaldet er synkront:
      // requestAnimationFrame koerer ikke i en skjult fane.
      repair(carousel);
      writeCounter(carousel, lastIndex);
      window.requestAnimationFrame(function () {
        repair(carousel);
        scrollActiveThumb(gallery);
      });
    };

    var onChange = function (event) {
      var detail = event && event.detail ? event.detail : {};
      if (typeof detail.activeIndex === 'number') lastIndex = detail.activeIndex;
      writeCounter(carousel, lastIndex);
      // Temaets media-gallery.js saetter --active-klassen paa samme event.
      // Vores lytter er tilfoejet senere, men vi venter en frame for at
      // vaere sikre paa at klassen er flyttet foer vi maaler.
      window.requestAnimationFrame(function () {
        scrollActiveThumb(gallery);
      });
    };

    carousel.addEventListener('on:media-carousel:init', onInit);
    carousel.addEventListener('on:media-carousel:slide-change', onChange);

    // Sikkerhedsnet hvis nogen aendrer listen uden at bygge galleriet om.
    var slideHost = carousel.querySelector('.js-slides');
    if (slideHost && 'MutationObserver' in window) {
      var observer = new MutationObserver(function () {
        writeCounter(carousel, lastIndex);
      });
      observer.observe(slideHost, { childList: true });
    }

    // Start-vaerdi, saa badgen ikke er tom foer foerste event.
    writeCounter(carousel, lastIndex);
  }

  /* Drejning eller skift mellem iPad- og telefonbredde.
     media-carousel.js bygger Swiper op paa ny paa sit eget braekpunkt og
     laeser attributten igen. Derfor saettes peek-tilstanden og repareres
     ogsaa her. Debounce, saa et swipe ikke afbrydes. */
  var resizeTimer = null;

  function onResize() {
    if (resizeTimer) window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(function () {
      resizeTimer = null;
      applyPeekState();
      var list = carousels();
      for (var i = 0; i < list.length; i += 1) repair(list[i]);
    }, 200);
  }

  function init() {
    applyPeekState();
    var list = carousels();
    for (var i = 0; i < list.length; i += 1) {
      try {
        bind(list[i]);
        repair(list[i]);
      } catch (err) {
        if (window.console && console.warn) {
          console.warn('[twrd-gallery-mobile] kunne ikke binde galleri', err);
        }
      }
    }
  }

  /* ---- Efter farve- eller print-skift ------------------------------------
     twrd-variant-gallery.js bygger galleriet om. Den nye <media-carousel>
     starter Swiper i en IntersectionObserver-callback, saa den er IKKE klar
     i samme tick. Uden dette stod karrusellen paa et gammelt slide indtil
     brugeren swipede.

     Derfor: vent (afgraenset) til carousel.initialized er sand.

     RAEKKEFOELGEN ER VIGTIG. Bliver listen kortere (10 -> 9 billeder),
     staar Swiper stadig med den gamle slide-liste et oejeblik. Et slideTo(0)
     foer Swipers egen update() blev derfor flyttet igen bagefter, og
     galleriet endte paa "2 / 9" i stedet for "1 / 9".

     Nu: update() foerst, saa slideTo(0, 0) uden animation, saa taelleren
     laest af Swipers eget indeks. Derefter lyttes der kort paa Swipers
     update-, slidesLengthChange- og observerUpdate-events og stilles paa
     plads igen, hvis en senere opdatering flytter indekset.

     Hvert skift faar et token. Et svar fra et tidligere skift kasseres,
     saa to hurtige skift ikke skriver oven i hinanden.

     Taelleren skrives uanset hvad: den laeser [data-slide] direkte og er
     derfor korrekt ogsaa uden Swiper. */
  var SYNC_MAX_TRIES = 30; // ~500 ms ved 60 fps
  var SETTLE_WINDOW = 600; // ms hvor senere Swiper-opdateringer rettes
  var renderToken = 0;

  /* Stiller paa foerste slide i den NYE liste og skriver taelleren.
     Kalder IKKE update(): den koeres af syncCarousel foerst, og et kald
     herfra ville udloese det event vi selv lytter paa. */
  function settle(carousel, swiper, token) {
    if (token !== renderToken || !carousel.isConnected) return;
    try {
      var index = typeof swiper.realIndex === 'number' ? swiper.realIndex : swiper.activeIndex;
      if (index !== 0) swiper.slideTo(0, 0, false);
    } catch (err) {
      /* Swiper kan vaere revet ned imens. */
    }
    writeCounter(carousel, 0);
    scrollActiveThumb(carousel.closest('media-gallery') || carousel.parentElement);
  }

  /* Har Swiper taget den nye, filtrerede liste til sig? Saa laenge dens
     egen slide-liste er kortere eller laengere end [data-slide] i DOM'en,
     arbejder den stadig paa den gamle liste. */
  function slidesApplied(carousel, swiper) {
    var total = slideTotal(carousel);
    if (!total) return false;
    var count = 0;
    try {
      if (swiper.virtual && swiper.virtual.slides) {
        count = swiper.virtual.slides.length;
      } else if (swiper.slides) {
        count = swiper.slides.length;
      }
    } catch (err) {
      return false;
    }
    return count === total;
  }

  /* Swipers egen opdatering kan komme efter vores. Vi lytter i et kort
     vindue og retter indekset igen. Lytterne fjernes bagefter, og et
     foraeldet token stopper dem med det samme.

     Swiper koerer med observer: true, saa enhver DOM-aendring giver et
     observerUpdate. Swiper brugeren i vinduet, maa vi IKKE trille tilbage
     til foerste billede. Derfor stopper det foerste slide-change fra
     karrusellen lytterne. Vores eget settle bruger runCallbacks = false og
     udloeser ikke det event. */
  function watchSettle(carousel, swiper, token) {
    if (!swiper || typeof swiper.on !== 'function' || typeof swiper.off !== 'function') return;
    var events = ['update', 'slidesLengthChange', 'observerUpdate'];
    var stopped = false;
    var handler = function () {
      if (token !== renderToken || !carousel.isConnected) {
        stop();
        return;
      }
      settle(carousel, swiper, token);
      // Har Swiper faaet hele den nye liste, og staar den paa foerste
      // billede, er der ikke mere at rette. Vi holder op med at lytte med
      // det samme, saa et swipe kort efter skiftet ikke trilles tilbage.
      if (slidesApplied(carousel, swiper) && activeIndex(carousel, 0) === 0) stop();
    };
    var stop = function () {
      if (stopped) return;
      stopped = true;
      for (var i = 0; i < events.length; i += 1) {
        try {
          swiper.off(events[i], handler);
        } catch (err) {
          /* Instansen kan vaere revet ned. */
        }
      }
      carousel.removeEventListener('on:media-carousel:slide-change', stop);
    };
    for (var i = 0; i < events.length; i += 1) {
      try {
        swiper.on(events[i], handler);
      } catch (err) {
        /* Ignoreres: settle koerer stadig en gang med det samme. */
      }
    }
    carousel.addEventListener('on:media-carousel:slide-change', stop);
    window.setTimeout(stop, SETTLE_WINDOW);
  }

  function syncCarousel(carousel, tries, token) {
    if (token !== renderToken || !carousel.isConnected) return;
    var ready = false;
    try {
      ready = Boolean(carousel.initialized);
    } catch (err) {
      ready = false;
    }
    if (ready) {
      var swiper = null;
      try {
        // media-carousel.slideTo() kalder selv swiper.update() og giver os
        // instansen. Det er update'en for den NYE slide-liste.
        swiper = typeof carousel.slideTo === 'function' ? carousel.slideTo(0, 0) : null;
      } catch (err) {
        swiper = null;
      }
      repair(carousel);
      if (!swiper) {
        writeCounter(carousel, 0);
        return;
      }
      settle(carousel, swiper, token);
      watchSettle(carousel, swiper, token);
      window.requestAnimationFrame(function () {
        settle(carousel, swiper, token);
      });
      return;
    }
    if (tries >= SYNC_MAX_TRIES) {
      // Swiper kom aldrig. Taelleren skal stadig vise den nye liste.
      writeCounter(carousel, 0);
      return;
    }
    window.requestAnimationFrame(function () {
      syncCarousel(carousel, tries + 1, token);
    });
  }

  function syncAfterRender() {
    renderToken += 1;
    var token = renderToken;
    init();
    var list = carousels();
    for (var i = 0; i < list.length; i += 1) syncCarousel(list[i], 0, token);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Shopify section-reload i temaeditoren.
  document.addEventListener('shopify:section:load', init);

  window.addEventListener('resize', onResize);
  window.addEventListener('orientationchange', onResize);

  // Farve- eller print-skift: galleriet er bygget om, noden er en ny kopi.
  // Bind om OG stil paa foerste billede i den nye liste.
  document.addEventListener('twrd:variant-gallery:rendered', syncAfterRender);
}());
